import imgchevauchement from "./checkSubtitleAssets/chevauchement.png"
import imgintervalle from "./checkSubtitleAssets/intervalle.png"
import imgintercp from "./checkSubtitleAssets/intercp.png"
import imglong from "./checkSubtitleAssets/long.png"
import imgcourt from "./checkSubtitleAssets/court.png"
import imglentext from "./checkSubtitleAssets/lentext.png"
import imglisibility from "./checkSubtitleAssets/lisibility.png"
import { monoBlue } from "react-syntax-highlighter/dist/esm/styles/hljs"
import { V2_secondsToFrames, V2_RoundedTimeCode } from "./timecodev2"
import { getCurrentLanguage } from "./software"

//  **********************************************************************************************
//  * fonctions de recherche de changements de plan
//		{
//			"offset" : 7386,
//			"size" : 1269,
//			"tc" : "00:00:16.160",
//			"time" : 16.16
//          "base64": jpeg datas (optional)
//		},
//  **********************************************************************************************
export function globalIsACp (timecode, cplist, tolerance)
{
    const index = cplist.findIndex(cp =>
    (cp.time >= (timecode - tolerance)) &&
    (cp.time <= (timecode + tolerance)) &&
    !cp.off
    );
    if (index === -1) return null;
    return {cp:cplist[index], index:index};
    
}

export function globalFindCpBefore (tc,cplist) 
// à utiliser avec cplist inverse
// const cplistinverse = cplist.slice().reverse();
{
    const cp = cplist?.find (cp => cp.time <= tc && !cp.off);  
    if (cp == undefined)
        return null;
    return cp;
}

export function globalFindCpAfter(tc,cplist)
{
    const cp = cplist?.find (cp => cp.time >= tc && !cp.off);  
    if (cp == undefined)
        return null; // tcmax
    return cp;
}

export function globalAddCP (cplist, newcp)
{
    const index = cplist.findIndex(item => item.time > newcp.time);
    if (index === -1) {
    // Si l'élément est plus grand que tous les autres, on le pousse à la fin
    cplist.push(newcp);
    } else {
    // Sinon, on l'insère avant le premier élément plus grand
    cplist.splice(index, 0, newcp);
    }    
    return cplist;
}

//  *****************************************************************************************
//  TCIN Automatique
//  *****************************************************************************************

export function getTCInFromPreviousSTorCP(subtitle, previousSubtitle, 
    stparams, firstTimeCode = 0, incplist = null)
{

    var cplist = stparams.cplist;
    if (incplist) cplist = incplist;
    
    var minstprevious = 0;
    if (previousSubtitle)
    {
        if (previousSubtitle.out >= subtitle.in) return subtitle.in;
        minstprevious = previousSubtitle.out;
    }

    var previouscp  = 0;
    if (cplist)
     {
        const cplistinverse = cplist.slice().reverse();

        const cpafter = cplistinverse.find (cp => (cp.time + firstTimeCode) > subtitle.in && 
                                              (cp.time + firstTimeCode) < (subtitle.in + 0.2) && 
                                              !cp.off);  
        if (cpafter !== undefined)
        {
            subtitle.in = cpafter.time + firstTimeCode + stparams.aftercp;
            return subtitle.in;
        }




        const cp = cplistinverse.find (cp => (cp.time+firstTimeCode) <= subtitle.in && !cp.off);  
        if (cp !== undefined)
            previouscp = cp.time + firstTimeCode;
    }


    if (previouscp > minstprevious)
        subtitle.in = previouscp + stparams.aftercp;
    else
        subtitle.in = minstprevious + stparams.interst;

    if ((subtitle.out - subtitle.in) > stparams.max)
        subtitle.out= subtitle.in + stparams.max;


    return subtitle.in;
}

//  *****************************************************************************************
//  TCOUT Automatique
//  *****************************************************************************************
export function getTCOutFromNextSTorCP(subtitle, nextSubtitle, stparams, firstTimeCode = 0, incplist = null)
{
    var cplist = stparams.cplist;
    if (incplist) cplist = incplist;


    var maxstnext = 999999;
    if (nextSubtitle)
    {
        if (nextSubtitle.in < subtitle.out) return subtitle.out;
        maxstnext = nextSubtitle.in;
    }

    var nextcp  = 0;
    if (cplist)
     {
        // cas particulier ou on est proche d'un cp juste avant

        const cpbefore = cplist.find (cp => (cp.time + firstTimeCode) > subtitle.in && 
                                              (cp.time + firstTimeCode) > (subtitle.out - 0.2) && 
                                              (cp.time + firstTimeCode) <= (subtitle.out) && 
                                              !cp.off);  
        if (cpbefore !== undefined)
        {
            subtitle.out = cpbefore.time + firstTimeCode - stparams.beforecp
            return subtitle.out;
        }

        const cp = cplist.find (cp => (cp.time + firstTimeCode) >= subtitle.out && !cp.off);  
        if (cp !== undefined)
            nextcp = cp.time + firstTimeCode;
    }

    

    if (nextcp > maxstnext)
        subtitle.out = maxstnext - stparams.interst;
    else
        subtitle.out = nextcp - stparams.beforecp

    if ((subtitle.out - subtitle.in) > stparams.max)
        subtitle.in= subtitle.out - stparams.max;


    return subtitle.out;



}


//  **********************************************************************************************
//  * fonction de calcul de lisbitilité en fonction des mots par minutes
//  **********************************************************************************************
export function getCharactersCountFromSubtitleLine(line)
{
    var ret = 0;
    line.words.forEach(word => {
        ret += (word.text.length + 1);
    });
    if (ret > 0) ret--;
    return ret;
}


export function getCharactersCountFromSubtitle(subtitle)
{
    var ret = 0;
    subtitle.lines.forEach(line => {
        ret += getCharactersCountFromSubtitleLine(line)
    });
    return ret;
}
//  ******************************************************************************************************
export function getWordsCountFromSubtitle(subtitle)
{
    var ret = 0;
    subtitle.lines.forEach(line => {
        ret += getWordsCountFromSubtitleLine(line)
    });
    return ret;
}

export function getWordsCountFromSubtitleLine(line)
{
    var ret = 0;
    line.words.forEach(word => {
        ret += getRealWordsCountFromWord(word.text);
    });
    return ret;
}

export function getRealWordsCountFromWord(word)
{
        // Supprime les espaces en début et fin, puis sépare sur un ou plusieurs espaces
        const mots = word.trim().split(/\s+/);
        // Si la phrase est vide, retourne 0
        return word.trim() === "" ? 0 : mots.length;
}



// cette fonction renvoie le nombre possible de mot pour une durée et une lisibilité par m/m
export function getWordsCountByDuration (lisibilityMM, duration)
{
    var ret = Math.round ((lisibilityMM/60) *  duration);


}

export function getIdealDuration(subtitle,stparams)
{

    var duree = subtitle.len / stparams.lisibilityIdeal;
    if (stparams.lisibilityMode !==0)
    {
        const wordcount = getWordsCountFromSubtitle(subtitle);
        duree = getDurationFromWordsCount(stparams.lisibilityMaxMM, wordcount);
    }

    if (duree < stparams.min) duree = stparams.min;
    if (duree > stparams.max) duree = stparams.max;
    return duree;



}


// cette fonction renvoie la durée par rapport à un nombre de mots
export function getDurationFromWordsCount (lisibilityMM, wordcount)
{
    return (wordcount * 60) /lisibilityMM;
}
export function getDurationFromWords(lisibilityMM, words, durationMin=0)
{
    const wordcount = getRealWordsCountFromWord(words);

    
    var ret = getDurationFromWordsCount(lisibilityMM, wordcount);
    if (ret < durationMin) ret = durationMin;
    return ret;


}

export function getNbWordsFromDuration(duration, lisibility)
{
    return Math.floor((duration * lisibility) / 60);
}


export function getNbChararterFromDuration (duration, lisibility)
{
    return Math.floor(duration * lisibility);
}

//  **********************************************************************************************
//  * fonction stabilos
//  **********************************************************************************************



export function getStabiloForTranscriptApp(ecart)
{
    if (ecart < 0.5) return {stabilo:0, color: "#300000"}; // on ne gere pas la couleur dans ce cas
    if (ecart < 1) return {stabilo:1, color: "#100000"}; // cas 1
    if (ecart < 2) return {stabilo:2, color: "#200000"}; // cas 1
    if (ecart < 3) return {stabilo:3, color: "#400000"}; // cas 1
    if (ecart < 4) return {stabilo:4, color: "#500000"}; // cas 1
    return {stabilo:5, color: "#600000"}; // cas 1
}

//  **********************************************************************************************
//  * fonction test sous titre
//  **********************************************************************************************


export function getLisibility (subtitle, stparams, lang="fr")
{
    const duration = subtitle.out - subtitle.in;
    var unit = "c/s";

    var nbideal=0;
    var nbmax = 0;
    var nb = 0;
    var nbunit = 0;

    switch (stparams.lisibilityMode)
    {
        case 0: // caractères par secondes

            nbunit = getCharactersCountFromSubtitle(subtitle);
            nbideal = getNbChararterFromDuration (duration, stparams.lisibilityIdeal);
            nbmax = getNbChararterFromDuration(duration, stparams.lisibilityMax);
            nb = getNbChararterFromDuration(duration, stparams.lisibility);

            unit = lang === "fr"?"chrs":"chrs";

            break;


        default: // mot par minute
            nbunit = getWordsCountFromSubtitle(subtitle);

            nbideal = getNbWordsFromDuration (duration, stparams.lisibilityIdealMM);
            nbmax = getNbWordsFromDuration (duration, stparams.lisibilityMaxMM);
            nb = getNbWordsFromDuration (duration, stparams.lisibilityMM);


            if (nbunit < 2)
                unit = lang === "fr"?"mot":"word";
            else
                unit = lang === "fr"?"mots":"words";
            break;
    }

    // calcul de la couleur

    var color = "black";
    if (nbunit < (nbideal * .9))
        color = "#0000FF";
    if (nbunit >nbmax)
        color = "#800000";
    if (nbunit >nbmax *1.1)
        color = "red";




    return {
        color: color,
        value : nbunit,
        ideal : nbideal,
        max : nbmax,
        default: nb,
        unit: unit,

    }

    return {action:"to do"};
}

export const subtitle_errors = {

    // tcstatus
    tcin: 1,
    tcout: 2,
    interin: 4,
    interout: 8,
    intercpin: 16,
    intercpout: 32,


    // ststatus
    durationshort: 1,
    durationlong: 2,
    lisibility: 4,

    // textstatus

    textlength: 1,




  }

export const subtitle_errorscolors = {
    noerror: "white",
    warning: "orange",
    critical:"red",
  }


function searchcp_plusProcheInferieureParTime(array, cible) {
  const inferieures = array.filter(obj => obj.time <= cible);
  if (inferieures.length === 0) return null; 
  return inferieures.reduce((max, obj) =>
    obj.time > max.time ? obj : max
    );
}
 

function searchcp_plusProcheSuperieureParTime(array, cible) {
  const superieures = array.filter(obj => obj.time > cible);
  if (superieures.length === 0) return null;
  return superieures.reduce((min, obj) =>
    obj.time < min.time ? obj : min
  );
}




export function checkSubtitle (previousSubtitle, subtitle, nextSubtitle, stparams, framerate=25, num=25,den=1, dropframe=0, timecode="00:00:00:00", language=null)
{
    // TO DO.....

    var tcstatus = 0;
    var ststatus = 0;
    var textstatus = 0;


    

    
    if (!subtitle) return null;                           

    subtitle.in = V2_RoundedTimeCode(subtitle.in,num,den,dropframe,timecode);
    subtitle.out = V2_RoundedTimeCode(subtitle.out,num,den,dropframe,timecode);

    const i_tcin = V2_secondsToFrames(subtitle.in, num, den, dropframe);
    const i_tcout = V2_secondsToFrames(subtitle.out, num, den, dropframe);


    if (previousSubtitle)
    {
        previousSubtitle.in = V2_RoundedTimeCode(previousSubtitle.in,num,den,dropframe,timecode);
        previousSubtitle.out = V2_RoundedTimeCode(previousSubtitle.out,num,den,dropframe,timecode);

        if (previousSubtitle.out > subtitle.in) 
            tcstatus +=subtitle_errors.tcin;
        else
        {
            const i_previoustcout = V2_secondsToFrames(previousSubtitle.out, num, den, dropframe);
            if ((i_tcin - i_previoustcout )< stparams.i_interst) tcstatus +=subtitle_errors.interin;
        }
    }

    if (nextSubtitle)
    {
        nextSubtitle.in = V2_RoundedTimeCode(nextSubtitle.in,num,den,dropframe,timecode);
        nextSubtitle.out = V2_RoundedTimeCode(nextSubtitle.out,num,den,dropframe,timecode);
        if (subtitle.out > nextSubtitle.in) tcstatus +=subtitle_errors.tcout;
        else
        {
            const i_nexttcin = V2_secondsToFrames(nextSubtitle.in, num, den, dropframe);
            if ((i_nexttcin - i_tcout )< stparams.i_interst) 
                tcstatus +=subtitle_errors.interout;
        }
    }


    if (subtitle.out <= subtitle.in)
    {
        tcstatus = tcstatus | subtitle_errors.tcin;   
        tcstatus = tcstatus | subtitle_errors.tcout;
    }

    if (previousSubtitle)
        if (previousSubtitle.out > subtitle.in)
            tcstatus = tcstatus | subtitle_errors.tcin;   
    
    if (nextSubtitle)
        if (nextSubtitle.in < subtitle.out)
            tcstatus = tcstatus | subtitle_errors.tcout;   



    // test sur la durée du sous titre si les tc ne sont pas en error
    if ((( (subtitle_errors.tcin & tcstatus)===0)) && ((subtitle_errors.tcout & tcstatus)===0))
    {
        const duree = i_tcout - i_tcin;

        if (duree < stparams.i_min)
        {
            ststatus = ststatus | subtitle_errors.durationshort;
            
        }
        else
            if (duree > stparams.i_max)
                ststatus = ststatus | subtitle_errors.durationlong;
    }


    // Test sur les changements de plans

    if ('cplist' in stparams)
    {
        if (stparams.cplist.length)
        {
            // In ?
            
            if ((tcstatus & (subtitle_errors.tcin + subtitle_errors.interin)) === 0) // c'est déja en erreur ?
            {
                
                const cpmax = searchcp_plusProcheInferieureParTime(stparams.cplist, subtitle.in);
                if (cpmax)
                {
                    if (subtitle.in < (cpmax.time + stparams.aftercp)) tcstatus = tcstatus | subtitle_errors.intercpin;
                }
            }

            // In ?
            
            if ((tcstatus & (subtitle_errors.tcout + subtitle_errors.interout)) === 0) // c'est déja en erreur ?
            {
                
                const cpmax = searchcp_plusProcheSuperieureParTime(stparams.cplist, subtitle.out);
                if (cpmax)
                {
                    
                    if (subtitle.out > (cpmax.time - stparams.beforecp)) tcstatus = tcstatus | subtitle_errors.intercpout;
                }
            }

        }
    }

    // tests sur les textes.............................................................

    // on cherche la ligne trop longue
    subtitle.len=0;
    if ("lines" in subtitle)
    {
        var stlen = 0;
        subtitle.lines.forEach (line =>{
            var iscolored = false;
            line.len  = 0;
            if ("words" in line)
            {
                var len = 0;
                line.words.forEach (word =>
                    {
                        if (word.text != "")
                        {
                            if (word.color.toUpperCase() != "#FFFFFF")
                                iscolored = true;
                            if (len) len++;
                            len += word.text.length;
                        }
                    })

                line.len = len;
                stlen += len;

                if (
                    ((iscolored ) && (len > stparams.maxLengthColor))
                    ||
                    (len > stparams.maxLength)
                )
                textstatus = textstatus | subtitle_errors.textlength;
                //console.log ("len st" , subtitle.id , len, stparams.maxLength, stparams.maxLengthColor)
            }
        })
    }
    subtitle.len = stlen;
    

    // lisibilité

    if (language == null) language = "fr";
    const lis = getLisibility (subtitle,stparams, language)
    //console.log(subtitle.id, lis)
    if (lis.value > lis.max) ststatus = ststatus | subtitle_errors.lisibility;
    return {
        tcstatus: tcstatus,
        ststatus: ststatus,
        textstatus: textstatus,
    }
}


export function getSubtitleErrorsInfos (subtitle)
{

  if (!subtitle) {
    return null;
  }

    var errorinfo =
    {
        icons: [],
        interbeforeBackcolor: "white",
        interafterBackcolor: "white",
        tcinBackcolor: "white",
        tcoutBackcolor: "white",
        textBackcolor: null,
    }

    if ('tcstatus' in subtitle)
    {
        if ((subtitle.tcstatus & 1) || (subtitle.tcstatus & 2))
        {
            errorinfo.icons.push ({img:imgchevauchement,name:"imgchevauchement",fr:"Chevauchement de time code", en:"Timecode overlap"});
            if (subtitle.tcstatus & 1 != 0) errorinfo.tcinBackcolor = subtitle_errorscolors.critical;
            if (subtitle.tcstatus & 2 != 0) errorinfo.tcoutBackcolor = subtitle_errorscolors.critical;
        }

        if ((subtitle.tcstatus & 4) || (subtitle.tcstatus & 8))
        {
            
            errorinfo.icons.push ({img:imgintervalle,name:"imgintervalle",fr:"Intervalle entre sous-titres", en:"Subtitles interval"});


            if (subtitle.tcstatus & 4) errorinfo.interbeforeBackcolor = subtitle_errorscolors.warning;
            if (subtitle.tcstatus & 8) errorinfo.interafterBackcolor = subtitle_errorscolors.warning;
        }

        if ((subtitle.tcstatus & 16) || (subtitle.tcstatus & 32))
        {
            errorinfo.icons.push ({img:imgintercp,name:"imgintercp",fr:"Trop près d'un C.P.", en:"To close to a shot"});
            if (subtitle.tcstatus & 16) errorinfo.interbeforeBackcolor = subtitle_errorscolors.warning;
            if (subtitle.tcstatus & 32) errorinfo.interafterBackcolor = subtitle_errorscolors.warning;

        }


    }
    if ('ststatus' in subtitle)
    {
        if (subtitle.ststatus & 1)
            errorinfo.icons.push ({img:imgcourt,name:"imgcourt",fr:"Durée trop courte", en:"Duration too short"});
        if (subtitle.ststatus & 2)
            errorinfo.icons.push ({img:imglong,name:"imglong",fr:"Durée trop longue", en:"Duration too long"});
        if (subtitle.ststatus & 4)
            errorinfo.icons.push ({img:imglisibility,name:"imglisibility",fr:"Lisibilité", en:"Lisibility"});

    }


    return errorinfo;

}
